import { failureToast } from "../../common/utils/methods/toasterFunctions/function"

export const regionAndBusinessModal = {
    region: [],
    businessArea: []
}

export const filterFormModal = {
    courseId: [],
    //  psid:'',
    classes: [],
    programAction: [],
    studentName: "",
    //  applicationId :"",
    allocationStatus: ''
}

export const searchInputFormModal = {
    studentName: '',
    psids: [],
    applicationIds: []
}

const inputParamInfo = {
    "applicationId": {
        dispLabel: "Application ID",
        validLength: 8
    },
    "psid": {
        dispLabel: "PSID",
        validLength: 11
    }
}

export const getInputParamRegex = inputParam => {
    if (["psid", "applicationId"].includes(inputParam)) return /^$|^\d+(,\d+)*(,)?$/;
    return null;
}

export const getUpdatedInputParamKey = inputParam => {
    if (["psid", "applicationId"].includes(inputParam)) return inputParam + "s";
    return inputParam;
}

export const getUpdatedUserInput = (userInput, inputParam) => {
    if (["psid", "applicationId"].includes(inputParam)) return getUserInputArr(userInput, inputParam);
    return userInput;
}

export const multiValuesSearchPasteHandler = (e, cb) => {
  e.preventDefault();

  const pastedText = e.clipboardData.getData('text');

  const sanitizedText =
    pastedText.match(/\d+/g)?.join(',') || '';

  cb(sanitizedText);
};

const getUserInputArr = (inputVal, inputParam) => {

    const { dispLabel, validLength } = inputParamInfo[inputParam]

    const inputValArr = inputVal?.split(",")?.filter(el => Boolean(el));
    const validInputValArr = inputValArr?.filter(el => el?.length === validLength);

    if (validInputValArr?.length > 25) {
        failureToast(`Please search a maximum of 25 ${dispLabel}s to proceed.`);
        return;
    }

    const noOfInValidInputs = inputValArr?.length - validInputValArr?.length;
    if (noOfInValidInputs === 1) failureToast(`1 ${dispLabel} is invalid`);
    if (noOfInValidInputs > 1) failureToast(`${noOfInValidInputs} ${dispLabel}s are invalid`);

    return validInputValArr;
}





